import { STORE_CLEAR } from '../constants/storeTypes';

export function storeClear() {
  return { type: STORE_CLEAR };
}



// WEBPACK FOOTER //
// ./app/actions/storeActions.js